import { object, string } from 'yup';

export const addCategoryValidationSchema = object({
  name: string().required('name is required!'),
  // Image: mixed().required('image is required dude!'),
});
